import React from "react";
import { Flex, Button } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Sizes } from "@jsq/ds/styles";
import { AppView } from "../../types";
import { useAnalyticsAI } from "../AnalyticsAI/context";
import { ChatHistoryPanel } from "../ChatHistoryPanel";
import * as styles from "./styles_vanilla.css";

export interface SideBarProps {
  onNewChatButtonClick: () => void;
  onHistoryButtonClick: () => void;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
  isChatCollapsed: boolean;
  onToggleChatCollapse: () => void;
  userId: number;
  arenaId: number;
  onHistoryItemClick: (conversationId: string) => void;
  view: AppView;
}

export const SideBar: React.FC = () => {
  const {
    isSideBarCollapsed,
    isChatCollapsed,
    toggleSideBarCollapse,
    toggleChatCollapse,
    startNewChat,
    loadConversation,
    view,
  } = useAnalyticsAI();

  return (
    <Flex
      flexDirection="column"
      gap={Sizes.SM}
      className={isSideBarCollapsed ? styles.sidebarCollapsed : styles.sidebar}
    >
      {isSideBarCollapsed && isChatCollapsed && view === "chat" && (
        <Button
          variant="neutral"
          icon="arrow-right-to-line"
          className={styles.chatCollapseButton}
          onClick={toggleChatCollapse}
          data-testid="sidebar-chat-collapse-button"
        />
      )}
      {isSideBarCollapsed && (
        <Button icon="plus" onClick={startNewChat} data-testid="sidebar-new-chat-button" />
      )}
      {!isSideBarCollapsed && (
        <Flex flexDirection="column" gap={Sizes.MD} className={styles.sidebarContent}>
          <Flex alignItems="center" justifyContent="space-between">
            <Button
              icon="plus"
              onClick={startNewChat}
              className={styles.newChatButtonExpanded}
              data-testid="sidebar-new-chat-button-expanded"
            >
              New chat
            </Button>
            <Flex gap={Sizes.MD} alignItems="center" justifyContent="center">
              <Icon
                type="times"
                variant="outline"
                className={styles.closeButton}
                onClick={toggleSideBarCollapse}
                data-testid="sidebar-close-icon"
                size="large"
              />
              {isChatCollapsed && (
                <Button
                  variant="neutral"
                  icon="arrow-right-to-line"
                  className={styles.chatCollapseButton}
                  onClick={toggleChatCollapse}
                  data-testid="sidebar-chat-collapse-button"
                />
              )}
            </Flex>
          </Flex>
          <ChatHistoryPanel onHistoryItemClick={loadConversation} />
        </Flex>
      )}
      {isSideBarCollapsed && (
        <Button
          variant="muted"
          onClick={toggleSideBarCollapse}
          icon="clock-rotate-left"
          data-testid="sidebar-history-button"
        />
      )}
    </Flex>
  );
};
